export default __webpack_public_path__ + "static/media/cif-za.5483112d.svg";